import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            affiliate_auto_approve: {
              tab_name: 'TAB_NAME',
              auto_accept_affiliate_request: 'ACCEPT_REQUEST',
              select_admin_for_all_languages: 'SELECT_ADMIN',
              search_by_admin_select_label: 'SEARCH_BY_ADMIN_SELECT_LABEL',
              search_button: 'SEARCH_BUTTON',
              reset_button: 'RESET_BUTTON',
              selected_group_label: 'SELECTED_GROUP_LABEL',
              unselected_group_label: 'UNSELECTED_GROUP_LABEL',
            },
          },
        },
      },
    },
  }));
}
